import React from "react";

import estilo from "./styles/Emision.module.css";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
// import required modules
import { Autoplay, Pagination, Navigation } from "swiper";
import { Link } from "react-router-dom";

function Emision({ emision }) {
  return (
    <Swiper
      slidesPerView={4}
      spaceBetween={15}
      centeredSlides={false}
      loop={true}
      autoplay={{
        delay: 3500,
        disableOnInteraction: false,
      }}
      pagination={{
        clickable: true,
      }}
      breakpoints={{
        0: {
          slidesPerView: 2,
        },
        576: {
          slidesPerView: 3,
        },
        768: {
          slidesPerView: 4,
        },
        960: {
          slidesPerView: 5,
        },
        1200: {
          slidesPerView: 4,
        },
      }}
      navigation={true}
      modules={[Autoplay, Pagination, Navigation]}
      className="mySwiper"
    >
      {emision.map((e, i) => (
        <SwiperSlide key={i}>
          <Link to={"/" + e.uid}>
            <div className={estilo.tarjetas}>
              <img src={e.portada} alt={e.nombre} className={estilo.slider} />
            </div>
          </Link>
        </SwiperSlide>
      ))}
    </Swiper>
  );
}

export default Emision;
